import { useEffect } from 'react';
import type { GetServerSideProps, NextPage } from 'next';
import { useRouter } from 'next/router';
import { useScreenViewEvent } from '@stitch-fix/event-reporter';
import { RegistrationForm } from '../../features/registration/components/RegistrationForm';
import { getIDmeRegistrationType, ID_ME_SIGNUP_TYPE_COOKIE_NAME } from '../../features/idme/utils';
import { getZipCodeProp } from '../../utils/registration/zipCode';
import { SignupMachineContext } from './signup-machine';
import { AwsWafScript } from '../../components/AwsWafScript';
type SignupPageProps = {
  zipCode?: string;
  idMeSignupType?: string;
  isDefaultSignupExperience: boolean;
};
export const getServerSideProps: GetServerSideProps<SignupPageProps> = async ({
  req,
  query
}) => {
  const idMeSignupType = req.cookies[ID_ME_SIGNUP_TYPE_COOKIE_NAME];
  const isDefaultSignupExperience = Array.isArray(query.default) ? query.default.includes('true') : query.default === 'true';
  return {
    props: {
      ...(await getZipCodeProp({
        req
      })),
      ...(idMeSignupType ? {
        idMeSignupType
      } : {}),
      isDefaultSignupExperience
    }
  };
};
const SignupPage: NextPage<SignupPageProps> = ({
  zipCode,
  idMeSignupType,
  isDefaultSignupExperience
}) => {
  const {
    EventProvider
  } = useScreenViewEvent({
    schema: 'screen_view',
    name: 'signup',
    locale: 'en-US',
    region: 'US',
    source_app: 'growth-next-ui'
  });
  const {
    query
  } = useRouter();
  useEffect(() => {
    const {
      boxoffer
    } = query;
    if (boxoffer) {
      const BOX_OFFER_FIRST_FIX = 'BOFF';
      try {
        // Set the box offer flag in local storage if they
        // come to this page with the boxoffer query param
        localStorage.setItem(BOX_OFFER_FIRST_FIX, 'SHOW');
      } catch (error) {
        console.error('Failed to set BOFF:', error);
      }
    }
  }, [query]);
  return <>
      <EventProvider>
        <SignupMachineContext.Provider options={{
        input: {
          zipCode,
          isWafEnabled: true,
          isDefaultSignupExperience,
          signupType: getIDmeRegistrationType({
            signupType: idMeSignupType
          })
        }
      }}>
          <RegistrationForm />
        </SignupMachineContext.Provider>
      </EventProvider>
      <AwsWafScript page="/signup" />
    </>;
};
export default SignupPage;